export enum BookingOrigin {
  UserApp = 'UserApp',
  BackOffice = 'BackOffice',
  DriverApp = 'DriverApp',
  WhatsApp = 'WhatsApp',
}
